<template>
  <div class="title">{{ title }}</div>
</template>

<script setup lang="ts">
  defineProps<{
    title: string;
  }>();
</script>

<style lang="scss" scoped>
  @use '@/assets/scss/variables' as vars;

  .title {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    height: 2.8358vw;
    padding: 0 1.5625vw;
    border-radius: 1.4179vw;
    background: #000000;
    color: #fff;
    font-size: 1.4925vw;
    @media (max-width: vars.$sm) {
      height: 24px;
      border-radius: 12px;
      font-size: 10px;
    }
  }
</style>
